export default {"src":"/_next/static/media/positionOpposition.c9582a4a.svg","height":400,"width":401,"blurWidth":0,"blurHeight":0};